export const createItemRelationships = (data) => {
	const view = [];
	const summaryTotals = new Map();
	const itemMap = new Map();

	for (const item of data || []) {
		if (!item.parent_id) {
			item.relationships = [];
			view.push(item);
		}

		const { brand_name, product_name, backend_name, item_type, value, quantity } = item;
		const summaryKey = `${brand_name}-${product_name}-${backend_name}`;

		if (summaryTotals.has(summaryKey)) {
			const summaryTotal = summaryTotals.get(summaryKey);
			summaryTotal.total += value.amount;
			summaryTotal.quantity += quantity;
		} else {
			summaryTotals.set(summaryKey, {
				key: summaryKey,
				brand_name,
				product_name,
				backend_name,
				type: item_type,
				total: value.amount,
				quantity,
			});
		}

		itemMap.set(item.sku, item);
	}

	for (const item of data || []) {
		if (item.parent_id) {
			const parent = itemMap.get(item.parent_id);
			if (parent) {
				const relationship = parent.relationships.find((relation) => [item.relationship_group, 'no_group'].includes(relation.relationship_group));
				if (relationship) {
					relationship.items.push(item);
				} else {
					parent.relationships.push({
						relationship_group: item.relationship_group || 'no_group',
						items: [item],
					});
				}
			}
		}
	}

	return {
		view,
		summaryTotals,
	};
};
